import { AdminOcupationDays } from '../model/adminOcupationDays';
export class AdminOcupationDaysBuilder {
    static buildAdminOcupationDays(data) {
        const adminOcupationDays = new AdminOcupationDays();
        adminOcupationDays.day = data.day;
        adminOcupationDays.reservations = data.reservations;
        return adminOcupationDays;
    }
}
//# sourceMappingURL=adminOcupationDays-builder.js.map